/**
 * 하드 리프레시(Ctrl/Cmd + Shift + R) 시 영구 저장된 store 를 초기화.
 *
 * 일반 새로고침은 그대로 두고, 사용자가 의도적으로 하드 리프레시를 누른
 * 시점에만 persist 데이터를 제거한다. 브라우저는 키 입력 후 새로고침을
 * 수행하므로, keydown 단계에서 localStorage 만 비워주면 다음 로드에서
 * 초기 상태로 시작된다.
 */

/** 하드 리프레시 시 제거할 localStorage 키 목록 */
const PERSISTED_STORAGE_KEYS = ["stage-storage"] as const;

const isHardRefresh = (e: KeyboardEvent): boolean => {
  if (e.key !== "R" && e.key !== "r") return false;
  if (!e.shiftKey) return false;
  // Windows/Linux: Ctrl + Shift + R, macOS: Cmd + Shift + R
  return e.ctrlKey || e.metaKey;
};

export const setupHardRefreshReset = (): void => {
  window.addEventListener("keydown", (e) => {
    if (!isHardRefresh(e)) return;
    for (const key of PERSISTED_STORAGE_KEYS) {
      localStorage.removeItem(key);
    }
  });
};
